import { Modal, ModalBody, ModalFooter, Button } from "@gpstrackit/react-controls";
import { useSelector, useDispatch } from "react-redux";
//Language
import { useIntl } from "react-intl";

//Actions
import {
    showCloneSettingsHide
} from 'Redux/actions';

//Styles
import "./cloneSettingsModal.scss";

const CloneSettingsModal = (props) => {
    const dispatch = useDispatch();
    const { messages } = useIntl();

    //redux states
    const openModal = useSelector(state => state.cloneSettingsModalRedux.openModal);

    const closeModal = () => {
        dispatch(showCloneSettingsHide());
    }

    return (
        <Modal
            open={openModal}
            title={messages['clone_settings_modal_title']}
            size="small"
            position="right"
            handleClose={() => closeModal()}
        >
            <ModalBody>

                <div className="restrictions-container">
                    {messages['clone_settings_modal_message']}
                </div>

            </ModalBody>
            <ModalFooter>
                <div className="restrictions-footer">
                    <Button
                        className="btn btn-cancel"
                        onClick={(e) => {
                            closeModal();
                        }}
                    >
                        {messages['clone_settings_modal_close']}
                    </Button>

                    <Button
                        className="btn btn-dark-blue"
                        onClick={(e) => {
                            //save
                            if (props.applySettingsClone)
                                props.applySettingsClone()
                            closeModal();
                        }}
                    >
                        {messages['vidfleet_configuration_apply_settings']}
                    </Button>
                </div>
            </ModalFooter>
        </Modal>
    )
}
export default CloneSettingsModal;